import { Button } from '@mui/material';
import Cropper from 'react-easy-crop';
import { useState } from "react";
import { imgPath } from './../App';

const PictureUpload = ({ userInfo, setUserInfo }) => {
  const [pictureData, setPictureData] = useState(null)
  const isMobile = /iPhone|Android.+Mobile|Windows Phone|webOS|BlackBerry/i.test(navigator.userAgent);
  const [crop, setCrop] = useState({ x: 0, y: 0 }); // 位置
  const [zoom, setZoom] = useState(1);              // 拡大率
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [isSelf, setIsSelf] = useState(false);

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels); // ← canvasで使う範囲
  };

  const uploadHandler = (e) => {
    const file = e.target.files[0];
    if (file) {
      e.target.value = ''; // ← 同じファイルでも再選択可能にする
      const reader = new FileReader();
      reader.onloadend = () => {
        setPictureData(reader.result)
      };
      reader.readAsDataURL(file);
    }
  };
  const Confirmhandler = async () => {
    try {
      const croppedImgDataUrl = await getCroppedImg(pictureData, croppedAreaPixels);

      // 例：Base64 を userInfo に反映
      setUserInfo(prev => ({
        ...prev,
        img: croppedImgDataUrl,
      }));

      setPictureData(null);                // Cropper非表示
      setCrop({ x: 0, y: 0 });             // 位置初期化
      setZoom(1);                          // ズーム初期化
      setCroppedAreaPixels(null);         // 切り取り領域リセット
      setIsSelf(false);                   // 自撮りモードのリセット（必要に応じて）
    } catch (error) {
      console.error('トリミングに失敗しました:', error);
    }
  };
  const getCroppedImg = async (imageSrc, croppedAreaPixels) => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    canvas.width = 100;
    canvas.height = 110;

    ctx.drawImage(
      image,
      croppedAreaPixels.x,
      croppedAreaPixels.y,
      croppedAreaPixels.width,
      croppedAreaPixels.height,
      0,
      0,
      canvas.width,
      canvas.height
    );

    return canvas.toDataURL('image/webp', 0.7);
  };
  const Cancelhandler = async () => {
    if (!pictureData) return;

    try {
      // WebP形式（100×110）の画像に変換
      const resizedBase64 = await resizeToWebP(pictureData, 100, 110, 0.7);

      // 加工なし画像をWebPにした形で反映
      setUserInfo(prev => ({
        ...prev,
        img: resizedBase64,
        status: 'valid',
      }));
    } catch (error) {
      console.error('画像変換に失敗しました:', error);
    }
    setPictureData(null);                // Cropper非表示
    setCrop({ x: 0, y: 0 });             // 位置初期化
    setZoom(1);                          // ズーム初期化
    setCroppedAreaPixels(null);         // 切り取り領域リセット
    setIsSelf(false);                   // 自撮りモードのリセット（必要に応じて）
  };

  return <>
    {pictureData && <div className='cropper-wrapper'>
      <Cropper
        crop={crop}
        zoom={zoom}
        aspect={1 / 1.1}
        onCropChange={setCrop}
        onZoomChange={setZoom}
        onCropComplete={onCropComplete}
        image={pictureData}
      />
      <div className='cropper-controller'>
        <Button
          variant="contained"
          disableElevation
          style={{ background: 'var(--blue)', color: '#fff' }}
          onClick={Confirmhandler}
          sx={{ width: "150px" }}
        >
          決定
        </Button>

        <Button
          variant="outlined"
          disableElevation
          sx={{ width: "150px" }}
          style={{ color: 'var(--blue)', borderColor: 'var(--blue)' }}
          onClick={Cancelhandler}
        >{isSelf ? `取り消し` : `このまま使う`}
        </Button>

      </div>
    </div>}
    <dl className="dl photo" style={{ margin: `16px auto` }}>
      <dt>
        <img src={userInfo.status !== 'invalid' && userInfo.img ? userInfo.img : `${imgPath}/images/dummy.jpg`} alt="" width={100} height={110} />
      </dt>
      <dd style={{ display: `grid` }}>
        <div>
          <input
            type="file"
            accept="image/*"
            id="upload-image"
            style={{ display: 'none' }}
            onChange={uploadHandler}
          />

          <label htmlFor="upload-image">
            <Button
              disableElevation
              variant="contained"
              component="span"
              onClick={() => setIsSelf(false)}
              style={{
                background: 'var(--blue)',
              }}>
              画像をアップロード
            </Button>
          </label>
          <br />
          <span style={{ color: `var(--red)`, fontSize: `12px` }}>※</span>

        </div>
        {isMobile && (
          <div>
            <input
              type="file"
              accept="image/*"
              capture="user" // インカメラなら "user"
              id="take-photo"
              style={{ display: 'none' }}
              onChange={uploadHandler}
            />
            <label htmlFor="take-photo">
              <Button variant="outlined" component="span"
                onClick={() => setIsSelf(false)}
                style={{
                  borderColor: 'var(--blue)',
                  color: 'var(--blue)',
                }}>
                カメラで撮影
              </Button>
            </label>
          </div>
        )}
      </dd>
    </dl>
    <details style={{ margin: `16px auto 24px`, background: `var(--gray)`, padding: `  8px 8px 0` }}>

      <summary style={{
        fontWeight: `bold`, marginBottom: `16px`
      }}>証明写真に関するご注意</summary>
      <p>この写真はセブ日本人会会員としての証明写真となります。以下の点に注意の上撮影をお願いします。</p>
      <ul style={{
        listStyle: `circle`,
        paddingBottom: `16px`
      }}>
        <li>無帽で撮影してください</li>
        <li>顔が正面を向いている状態で撮影してください</li>
        <li>過度な画像加工は行わないでください（輪郭補正など）</li>
        <li>タンクトップ、オフショルダーなど露出度の高い服装は避けてください</li>
        <li>背景は可能な限り模様のない無地が望ましいですが、難しい場合は顔が明瞭に認識できる環境で撮影してください</li>
      </ul>
    </details>
  </>
}
export default PictureUpload

const createImage = (url) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    img.crossOrigin = 'anonymous'; // CORS回避（Base64なら不要だけど保険）
    img.onload = () => resolve(img);
    img.onerror = (err) => reject(err);
  });
const resizeToWebP = (dataUrl, width, height, quality = 0.8) => {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);

      const webpDataUrl = canvas.toDataURL('image/webp', quality);
      resolve(webpDataUrl);
    };
    img.src = dataUrl;
  });
};
